import { InstantSearchStatus } from '../types/InstantSearchStatus.ts';
import { SearchState } from '../types/SearchState.ts';

export const isLoadingOrStalled = (status: InstantSearchStatus) => {
  return status === SearchState.Stalled || status === SearchState.Loading;
};
